import React, { useState } from 'react';
import { Backdrop, Button, Stack } from '@mui/material';
import { Price3DigitSplitter } from 'utils/Price3DigitSplitter';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { selectedDoctorAtom } from '../../shared/selected.doctor';
import { useAtom } from 'jotai';
import { selectedDayAtom } from '../../shared/selected.day';
import { selectedTimeAtom } from '../../shared/selected.time';
import { selectedPortal } from '../../shared/selected.portal';
import { HandleOperatePaymentPortal } from '../../functions/HandleOperatePaymentPortal';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import Cookies from 'js-cookie';
import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import PaymentOptions from '../PaymentOptions/PaymentOptions';
import PaymentPortals from '../PaymentPortals/PaymentPortals';
import SamanKishTokenForm from 'Global/Components/CommonComponents/SamanKishTokenForm/SamanKishTokenForm';
import useCheckActivatedPaymentGateways from 'Global/Hooks/useCheckActivatedPaymentGateways/useCheckActivatedPaymentGateways';
import { CheckPardakhtBeforSave } from '../../adapaters/CheckPardakhtBeforSave';

const PayOptionBackdrop = ({
  openBackdrop,
  setBackdrop,
  priceTag,
  doctorList,
  navigate,
  confirmMsg,
  nearestTurn,
  steps,
}) => {
  const [selectedDoctor] = useAtom(selectedDoctorAtom);
  const [selectedDay] = useAtom(selectedDayAtom);
  const [selectedTime] = useAtom(selectedTimeAtom);

  const doctorInfo = `${ArabicToPersian(
    selectedDoctor?.nameDoctor ||
      selectedDoctor?.doctor?.nameDoctor
  )} ${ArabicToPersian(
    selectedDoctor?.familyDoctor ||
      selectedDoctor?.doctor?.familyDoctor ||
      ''
  )} ${ArabicToPersian(
    selectedDoctor?.speciality?.Name ||
      selectedDoctor?.doctor?.speciality?.Name ||
      ''
  )} - `;

  const price = FindLangKey('freeze-contracts-label-price');
  const wallet = FindLangKey(
    'get-new-turn-payment-based-on-wallet'
  );
  const direct_pay = FindLangKey(
    'get-new-turn-payment-based-on-direct-payment'
  );

  const backwardMsg = FindLangKey('get-new-turn-back-step');
  const continueMsg = FindLangKey(
    'general-public-label-approve'
  );

  const select_portal_label = FindLangKey(
    'get-new-turn-select-payment-label'
  );
  const Zarin_pal_label = FindLangKey(
    'get-new-turn-select-zarin-pal-portal'
  );
  const Saman_kish_label = FindLangKey(
    'get-new-turn-select-saman-kish-pal-portal'
  );

  const user = JSON.parse(Cookies.get('user'));
  const idPatient = JSON.parse(
    Cookies.get('user')
  )?.IdPatient;

  const [paymentMode, setPaymentMode] = useState(null);
  const [enablePortalOptions, setEnablePortalOptions] =
    useState(false);
  const [portal] = useAtom(selectedPortal);

  const [samanToken, setSamanToken] = useState('');

  const gateways = useCheckActivatedPaymentGateways();

  const isSamanKishEnabled =
    typeof gateways !== 'string' &&
    gateways &&
    gateways?.findIndex((item) => item.Id === 2) !== -1;

  const isZarinPalEnabled =
    typeof gateways !== 'string' &&
    gateways &&
    gateways?.findIndex((item) => item.Id === 1) !== -1;

    const idNobat = Number(
  
      selectedTime?.Id
    );

  const HandleContinuePayment = (paymentMode, portal) => {

    

    if (!portal) {
      if (paymentMode === 0){
        CheckPardakhtBeforSave({
          idPatient,
          idNobat,
          doctorList,
          user,
          navigate,
          isWallet: priceTag,
          doctorInfo,
        });
      }
      if (paymentMode === 1) {
        setEnablePortalOptions(true);
      }
      return;
    }
    HandleOperatePaymentPortal(portal, {
      paymentMode,
      doctorList,
      navigate,
      confirmMsg,
      nearestTurn,
      selectedDay,
      selectedTime,
      doctorInfo,
      steps,
      idPatient,
      idNobat: Number(selectedTime?.Id),
      isWallet: priceTag,
      user,
      paymentMode,
      setSamanToken,
      isSamanKishEnabled,
      isZarinPalEnabled,
    });
  };

  // console.log('selectedDoctor===>', selectedDoctor);

  // console.log('samanToken=>', samanToken);

  return (
    <React.Fragment>
      <SamanKishTokenForm token={samanToken} />
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={openBackdrop}
        // onClick={() => {
        //   setBackdrop(false);
        // }}
      >
        <FrameCard
          cardProps={{
            p: '.4em',
            borderRadius: '20px',
            width: '22em !important',
            minWidth: '22em !important',
          }}
          jsx={
            <div
              style={{
                backgroundColor: 'white',
                width: '22em !important',
                minWidth: '22em !important',
                padding: '.5em',
                borderRadius: '20px',
                paddingBlock: '1em',
              }}
            >
              <p
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: '100%',
                  alignItems: 'center',
                  minHeight: '40px',
                  borderRadius: '.3em',
                  fontWeight: 'bolder',
                  fontSize: '1.2em',
                  border: '1px solid gray',
                  marginBottom: '.5em',
                }}
              >
                {price} {Price3DigitSplitter(priceTag)}
                 ریال 
              </p>

              {!enablePortalOptions ? (
                <PaymentOptions
                  paymentMode={paymentMode}
                  setPaymentMode={setPaymentMode}
                  wallet={wallet}
                  direct_pay={direct_pay}
                />
              ) : (
                <PaymentPortals
                  label={select_portal_label}
                  ZpLabel={Zarin_pal_label}
                  SmLabel={Saman_kish_label}
                />
              )}

              <Stack mt="1em" direction="row" gap=".5em">
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    color: `${themeColors.ColorPrimary} !important`,
                  }}
                  onClick={() => {
                    if (enablePortalOptions) {
                      setEnablePortalOptions(false);
                      return;
                    }

                    setBackdrop(false);
                    setPaymentMode(null);
                  }}
                >
                  {backwardMsg}
                </Button>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    color: `${themeColors.ColorPrimary} !important`,
                  }}
                  onClick={() => {
                    HandleContinuePayment(
                      paymentMode,
                      portal
                    );
                  }}
                >
                  {continueMsg}
                </Button>
              </Stack>
            </div>
          }
        />
      </Backdrop>
    </React.Fragment>
  );
};

export default PayOptionBackdrop;
